export enum TransportMethodDTO {
    BOAT = 'boat',
    PLANE = 'plane',
    TRAIN = 'train',
    TRUCK = 'truck'
}